document.addEventListener('DOMContentLoaded', function () {

  // ── ZOOM IMAGE (desktop) ──────────────────────────────
  function initZoom() {
    const mediaItems = document.querySelectorAll(
      '.product__media img, .product-media-container img'
    );

    mediaItems.forEach(function (img) {
      const container = img.closest(
        '.product__media, .product-media-container'
      );
      if (!container) return;

      container.classList.add('zoom-container');

      container.addEventListener('mousemove', function (e) {
        const rect = container.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        container.style.setProperty('--zoom-x', x + '%');
        container.style.setProperty('--zoom-y', y + '%');
      });

      container.addEventListener('mouseleave', function () {
        container.style.setProperty('--zoom-x', '50%');
        container.style.setProperty('--zoom-y', '50%');
      });
    });
  }

  initZoom();
  document.addEventListener('variant:change', initZoom);

  // ── AUTOPLAY VIDEO (mobile + desktop) ────────────────
  function initVideoAutoplay() {
    // Sélecteurs élargis pour couvrir tous les cas Dawn
    const videos = document.querySelectorAll(
      'video, .product__media video, .media video, ' +
      'deferred-media video, .product-media-container video'
    );

    videos.forEach(function (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('loop', '');

      // Forcer le chargement puis play
      video.load();
      video.play().catch(function (e) {
        console.log('Autoplay bloqué:', e);
      });
    });

    // Gérer aussi les deferred-media de Dawn
    const deferredMedias = document.querySelectorAll('deferred-media');
    deferredMedias.forEach(function (dm) {
      const btn = dm.querySelector('.deferred-media__poster-button');
      if (btn) btn.click(); // Déclenche le chargement de la vidéo
    });
  }

  initVideoAutoplay();
  document.addEventListener('variant:change', initVideoAutoplay);

  // Observer pour détecter les vidéos chargées dynamiquement
  const observer = new MutationObserver(function () {
    initVideoAutoplay();
  });

  const gallery = document.querySelector(
    '.product__media-list, .product-media-container'
  );
  if (gallery) {
    observer.observe(gallery, { childList: true, subtree: true });
  }

});